import * as React from 'react';
import { AnchorListItem } from './AnchorListItem';
import { AppName } from '@pec/aion-ui-core/interfaces/appName';
import { DotBadge } from '../DotBadge';
import { faFileSignature } from '@fortawesome/free-solid-svg-icons/faFileSignature';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { InlineBadge } from '../InlineBadge';
import { NavLinkListItem } from './NavLinkListItem';
import { useTranslation } from 'react-i18next';

type Props = {
  navExpanded: boolean;
  notificationCount: number | null;
  organizationId: string;
};

const icon = <FontAwesomeIcon icon={faFileSignature} style={{ fontSize: 25, marginLeft: 5 }} />;

export const EsignatureComponent: React.FC<Props> = ({ navExpanded, notificationCount, organizationId }) => {
  const showDotBadge = !navExpanded && notificationCount;
  const { t } = useTranslation();

  return process.env.REACT_APP_NAME === AppName.AionEsignatureUI ? (
    <NavLinkListItem
      tooltip={!navExpanded}
      divider
      icon={showDotBadge ? <DotBadge>{icon}</DotBadge> : icon}
      to={`/${organizationId}/esignatures/documents`}
    >
      <InlineBadge badgeContent={notificationCount}>
        {t('components.esignature.eSignatures', 'eSignatures')}
      </InlineBadge>
    </NavLinkListItem>
  ) : (
    <AnchorListItem
      tooltip={!navExpanded}
      divider
      icon={showDotBadge ? <DotBadge>{icon}</DotBadge> : icon}
      href={`/organizations/${organizationId}/esignatures/documents`}
    >
      <InlineBadge badgeContent={notificationCount}>
        {t('components.esignature.eSignatures', 'eSignatures')}
      </InlineBadge>
    </AnchorListItem>
  );
};
